/**
 * @fileoverview User display-name / initials helpers.
 *
 * Split out of `user-avatar.tsx` (react-refresh/only-export-components).
 */

/**
 * Generates initials from user name or email.
 *
 * Priority:
 * 1. First letter of firstName + first letter of lastName (e.g. "JA")
 * 2. First two letters of firstName (e.g. "JO")
 * 3. First letter of email (e.g. "J")
 * 4. Fallback "?"
 */
export function getInitials(
  firstName?: string,
  lastName?: string,
  email?: string,
): string {
  if (firstName && lastName) {
    return `${firstName[0]}${lastName[0]}`.toUpperCase();
  }
  if (firstName) {
    return firstName.slice(0, 2).toUpperCase();
  }
  if (email) {
    return email[0].toUpperCase();
  }
  return "?";
}

/**
 * Builds a display name from first/last name or email.
 */
export function getDisplayName(
  firstName?: string,
  lastName?: string,
  email?: string,
): string {
  const fullName = [firstName, lastName].filter(Boolean).join(" ");
  return fullName || email || "";
}
